import { render } from "./NewMainBranch.vue?vue&type=template&id=1e421a0e"
import script from "./NewMainBranch.vue?vue&type=script&lang=js"
export * from "./NewMainBranch.vue?vue&type=script&lang=js"

import "./NewMainBranch.vue?vue&type=style&index=0&id=1e421a0e&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__